import { defineComponent as r, openBlock as p, createBlock as a, unref as l, mergeProps as m, withCtx as i, createElementVNode as o } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconEmojiHappy",
  __name: "IconEmojiHappy",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (d, e) => (p(), a(l(c), m(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        o("path", { d: "M14.298 13.92a.75.75 0 1 1 1.06 1.06 4.75 4.75 0 0 1-6.716 0 .75.75 0 1 1 1.06-1.06 3.25 3.25 0 0 0 4.596 0M8.5 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7.009 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m0 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
